import React, { useState } from 'react';
import './Team.css'; 
import balajikumar from '../../../assets/BalajiKumar.P.jpeg';
import venkatesh from '../../../assets/Venkatesh.K.jpeg';
import kanagaraj from '../../../assets/Kanagaraj.N.jpeg';
import sugumar from '../../../assets/Sugumar.A.jpeg';
import bobBrownImage from '../../../assets/Sugumar.A.jpeg';

const partnersData = [
    {
        name: 'BalajiKumar P',
        image: balajikumar,
        linkedin: 'https://www.linkedin.com/in/johndoe',
    },
    {
        name: 'Venkatesh K',
        image: venkatesh,
        linkedin: 'https://www.linkedin.com/in/janesmith',
    },
    {
        name: 'Kanagaraj N',
        image: kanagaraj,
        linkedin: 'https://www.linkedin.com/in/johndoe',
    },
    {
        name: 'Sugumar A',
        image: sugumar,
        linkedin: 'https://www.linkedin.com/in/janesmith',
    },
];

const employeesData = [
    {
        name: 'Alice Johnson',
        image: bobBrownImage,
        linkedin: 'https://www.linkedin.com/in/alicejohnson',
    },
    {
        name: 'Bob Brown',
        image: bobBrownImage,
        linkedin: 'https://www.linkedin.com/in/bobbrown',
    },
];

const Team = () => {
    const [viewMode, setViewMode] = useState('board');

    return (
        <div>
            <div className="partners-title-container">
                <h1>Our Team</h1>
            </div>
            
            <div className="button-container">
                <button
                    className={`toggle-button ${viewMode === 'all' ? 'active' : ''}`}
                    onClick={() => setViewMode('all')}
                >
                    Meet Everyone
                </button>
                <button
                    className={`toggle-button ${viewMode === 'board' ? 'active' : ''}`}
                    onClick={() => setViewMode('board')}
                >
                    Board of Directors
                </button>
                <button
                    className={`toggle-button ${viewMode === 'employees' ? 'active' : ''}`}
                    onClick={() => setViewMode('employees')}
                >
                    The People Behind Us
                </button>
            </div>

            {(viewMode === 'board' || viewMode === 'all') && (
                <div className="partners-grid">
                    {partnersData.map((partner, index) => (
                        <div className="partner-card" key={index}>
                            <img src={partner.image} alt={partner.name} className="partner-image" />
                            <h3 className="partner-name">{partner.name}</h3>
                            <a
                                href={partner.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="linkedin-icon"
                            >
                                <i className="fab fa-linkedin"></i>
                            </a>
                        </div>
                    ))}
                </div>
            )}

            {(viewMode === 'employees' || viewMode === 'all') && (
                <div className="partners-grid">
                    {employeesData.map((employee, index) => (
                        <div className="partner-card" key={index}>
                            <img src={employee.image} alt={employee.name} className="partner-image" />
                            <h3 className="partner-name">{employee.name}</h3>
                            <a
                                href={employee.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="linkedin-icon"
                            >
                                <i className="fab fa-linkedin"></i>
                            </a>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Team;
